module.exports = __webpack_public_path__ + "img/forks_grab.cb19beda.jpg";